import { KeyboardBindType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { isEmpty } from "lodash";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import useAppSelector from "@/core/helpers/useAppSelector";
import { NotificationItemOffer } from "@/stores/notifications/notificationStore";
import useOfferHandlers from "@/domains/notifications/hooks/useOfferHandlers.ts";
import NotificationsOfferBody from "@/domains/notifications/components/NotificationsOfferBody";
import NotificationsOfferButton from "@/domains/notifications/components/NotificationsOfferButton";
import NotificationsOfferLoader from "@/domains/notifications/components/NotificationsOfferLoader";
import { controlSettingsSelector } from "@/domains/settings/control/slice";
import KeyCode from "@/assets/constants/key-code";

type Props = {
  item: NotificationItemOffer;
};

export default function NotificationsOfferContainer({ item }: Props) {
  const controlSettings = useAppSelector(controlSettingsSelector);
  const { t } = useTranslation("notifications");
  const { type, baseCharacterId, baseCharacterName } = item.data;
  const { acceptHandler, declineHandler } = useOfferHandlers();

  const accept = useCallback(() => {
    acceptHandler(item.id, item);
  }, [acceptHandler, item]);

  const decline = useCallback(() => {
    declineHandler(item.id);
  }, [declineHandler, item.id]);

  if (isEmpty(controlSettings)) return null;

  return (
    <NotificationsOfferBody
      text={t(`offer.${type}.title`, {
        id: baseCharacterId,
        name: baseCharacterName,
      })}
    >
      <NotificationsOfferButton
        label={KeyCode[controlSettings[KeyboardBindType.ACCEPT].key]}
        description={t(`offer.${type}.apply_button`)}
        isApply
        onClick={accept}
      />
      <NotificationsOfferButton
        label={KeyCode[controlSettings[KeyboardBindType.DECLINE].key]}
        description={t(`offer.${type}.cancel_button`)}
        onClick={decline}
      />
      <NotificationsOfferLoader delay={5000} />
    </NotificationsOfferBody>
  );
}
